import { createOrGetVisitor } from './Visitor';
import EventBus from './EventBus';
import { getIdentity } from './Identity';
import { getCatalogueId } from './Catalogue';
import httpRequestLib from './Request';
import { qsApiHost } from '../../config';

const checkBlock = (phone, { catalogueId } = {}) => {
  httpRequestLib({
    method: 'GET',
    url: `${qsApiHost}/v1/catalogue/phone-blocked?catalogueId=${
      catalogueId || getCatalogueId()
    }&phone=${encodeURIComponent(phone)}`
  })
    .then((result) => {
      if (result && result.isBlocked) {
        window.location.href = '/s/error';
      }
    })
    .catch(() => {});
};

const onIdentityChanged = () => {
  const catalogueId = getCatalogueId();

  getIdentity()
    .then((identity) => {
      if (identity && identity.phone) {
        checkBlock(identity.phone, { catalogueId });
      }
    })
    .catch(() => {});
};

export const initialize = () => {
  const catalogueId = getCatalogueId();

  EventBus.addListener(EventBus.TYPE.IDENTITY_CHANGED, onIdentityChanged);

  createOrGetVisitor()
    .then((visitor) => {
      if (visitor && visitor.phone) {
        checkBlock(visitor.phone, { catalogueId });
      }
    })
    .catch(() => {});
};

export const cancel = () => {
  EventBus.removeListener(EventBus.TYPE.IDENTITY_CHANGED, onIdentityChanged);
};
